<template>
  <div class="main lh-15 c-666">
    <ProductBanner
      :banner-img="bannerImg"
      :product-name="$t('common.productName.wifiCamera')"
      :main-title="$t('common.productName.wifiCamera')"
    >
    </ProductBanner>
    <!-- banner:end -->
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor :product-name="$t('common.productName.wifiCamera')" />
      <!-- nav-anchor:end -->
      <div class="area-1">
        <IconWrap :icon-wrap-data="iconWrapData" id="overview" />
      </div>
      <!-- area-1:end -->
      <div class="area-2">
        <ImgDesc :is-reverse="1" :img-desc-data="area2Data" />
      </div>
      <!-- area-2:end -->
      <div class="area-3">
        <ImgDesc
          :is-reverse="1"
          :custom-style="'mb-16'"
          :is-re="false"
          :main-title="area3Title"
          :img-desc-data="ara3Data"
        />
      </div>
      <!-- area-3:end -->
      <div class="area-4">
        <!-- 常规轮播 -->
        <Carousel id="accessories" ref="carousel" :swiper-option="swiperOption" :swiper-data="swiperCarouseData" />
      </div>
      <!-- area-4:end -->
      <div class="area-5">
        <ImgDesc :is-reverse="1" :main-title="area5Title" :img-desc-data="ara5Data" />
      </div>
      <!-- area-5:end -->
      <div class="area-6 w-12r m-a">
        <div class="text-wrapper d-f">
          <div v-for="(item, index) in area6Text" :key="index">
            <h3 class="c-333 ta-c">{{ item.title }}</h3>
            <div class="desc" v-html="item.desc"></div>
          </div>
        </div>
        <div class="img-wrapper d-f fw-w">
          <div v-for="(item, index) in area6Imgs" :key="index">
            <img :src="item.imgSrc" :alt="item.alt" width="100%" height="100%" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import IconWrap from '@/components/IconWrap'
  import ImgDesc from '@/components/ImgDesc'
  import Carousel from '@/components/Carousel'

  import bannerScroll from '@/mixins/bannerScroll.js'

  const carouseTabItem = ['Front view', 'Rear view']

  export default {
    components: {
      ProductBanner,
      NavAnchor,
      IconWrap,
      ImgDesc,
      Carousel
    },
    mixins: [bannerScroll],
    data() {
      const vm = this
      return {
        bannerImg: require('@/assets/images/powersec/banner.jpg'),
        iconWrapData: [
          {
            icon: 'wifi-area-1-icon01',
            vHtml: 'products.wificamera.area1Icon1'
          },
          {
            icon: 'wifi-area-1-icon02',
            vHtml: 'products.wificamera.area1Icon2'
          },
          {
            icon: 'wifi-area-1-icon03',
            vHtml: 'products.wificamera.area1Icon3'
          },
          {
            icon: 'wifi-area-1-icon04',
            vHtml: 'products.wificamera.area1Icon4'
          },
          {
            icon: 'wifi-area-1-icon05',
            vHtml: 'products.wificamera.area1Icon5'
          },
          {
            icon: 'wifi-area-1-icon06',
            vHtml: 'products.wificamera.area1Icon6'
          }
        ],
        area2Data: [
          {
            imgSrc: require('@/assets/images/wificamera/area-2.jpg'),
            title: this.$t('common.productName.wifiCamera'),
            desc: "FJDynamics WiFi camera' automatic sensing for light intensity and infrared night vision support all-weather operations. With the display terminal in the guidance system, the driver can monitor both virtual and real scenes on one screen, making the operation more reliable."
          }
        ],
        area3Title: 'products.wificamera.area3Title',
        ara3Data: [
          {
            imgSrc: require('@/assets/images/wificamera/area_2_1.jpg'),
            title: this.$t('products.autoKit.bannerTitle') + this.$t('products.autoKit.subTitle'),
            desc: 'Provides stable RTK data for mobile devices with radio module and allows agricultural machinery to achieve centimeter-level positioning accuracy.',
            link: '/product/autosteeringkit',
            icon: 'arr-icon'
          },
          {
            imgSrc: require('@/assets/images/wificamera/area_2_2.jpg'),
            title: this.$t('common.productName.A13D'),
            desc: 'Provides centimeter-level accuracy for farmland leveling, helping optimize water management, improve productivity, and increase yields.',
            link: '/product/excavatorguidance',
            icon: 'arr-icon'
          }
        ],
        swiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet: (index, className) => {
              return '<span style="width:50%" class="' + className + '">' + this.$t(carouseTabItem[index]) + '</span>'
            }
          },
          on: {
            init: () => {
              this.$refs.carousel.$refs.swiperLine.style.width = `50%`
            },
            slideChange() {
              const index = this.realIndex
              vm.$refs.carousel.$refs.swiperLine.style.transform = `translateX(${index * 100}%)`
            }
          }
        },
        swiperCarouseData: [
          {
            img: require('@/assets/images/wificamera/area-4-1.png'),
            desc: 'The control terminal could be connected to 2 cameras, and real-time images could be monitored and switched anytime. In addition, up to 4 cameras can be connected to meet specific needs.'
          },
          {
            img: require('@/assets/images/wificamera/area-4-2.png'),
            desc: 'The control terminal could be connected to 2 cameras, and real-time images could be monitored and switched anytime. In addition, up to 4 cameras can be connected to meet specific needs.'
          }
        ],
        area5Title: 'Features',
        ara5Data: [
          {
            imgSrc: require('@/assets/images/wificamera/area-5-1.jpg'),
            title: 'HD video 1080P',
            desc: 'Max transmission rate 150Mbps.Max transmission distance 20m.'
          },
          {
            imgSrc: require('@/assets/images/wificamera/area-5-2.jpg'),
            title: 'IP65 waterproof for harsh environment',
            desc: 'Quick multi-angle installation without drilling.'
          },
          {
            imgSrc: require('@/assets/images/wificamera/area-5-3.jpg'),
            title: 'Auto-connect after restart',
            desc: 'Installed anywhere with power supply.'
          }
        ],
        area6Text: [
          {
            title: 'Traditional Wired Camera',
            desc: 'Only can be installed around the tractor cab. Limited field of view,<br>a large number of locations to be monitored are obscured.'
          },
          {
            title: 'FJD Wi-Fi Camera',
            desc: 'Can be installed anywhere with power supply, Providing unprecedented perspectives for the driver.'
          }
        ],
        area6Imgs: [
          {
            imgSrc: require('@/assets/images/wificamera/area-6-1.jpg'),
            alt: 'Traditional Wired Camera'
          },
          {
            imgSrc: require('@/assets/images/wificamera/area-6-2.jpg'),
            alt: 'FJD Wi-Fi Camera'
          },
          {
            imgSrc: require('@/assets/images/wificamera/area-6-3.jpg'),
            alt: 'Traditional Wired Camera'
          },
          {
            imgSrc: require('@/assets/images/wificamera/area-6-4.jpg'),
            alt: 'FJD Wi-Fi Camera'
          }
        ]
      }
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .mb-16 {
    margin-bottom: 0.16rem;
  }
  .area-2 {
    padding-top: 1.6rem;
  }
  :deep(.area-2 .img-desc .img-box) {
    width: 7.44rem;
    height: 4.19rem;
  }
  :deep(.area-2 .img-desc .text) {
    background-color: transparent;
  }
  :deep(.area-2 .img-desc .text strong) {
    font-size: 0.48rem;
  }
  :deep(.area-3 .img-desc .img-box) {
    height: auto;
  }
  :deep(.area-3 .img-desc .text strong) {
    margin-top: 0.24rem;
  }
  :deep(.area-4 .area-8-swiper .img-box) {
    width: 8.2rem;
    height: 4.64rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1.35rem;
  }
  :deep(.area-4 .area-8-swiper-tab-wrap) {
    top: 4.9rem;
  }
  :deep(.area-4 .swiper-carousel) {
    padding-top: 0;
    padding-bottom: 1.6rem;
  }

  .area-6 {
    padding-bottom: 1.6rem;
    .text-wrapper {
      & > div {
        width: 50%;
      }
      & > div:nth-of-type(2) {
        margin-left: 0.16rem;
      }
      h3 {
        font-size: 0.28rem;
      }
      .desc {
        margin: 0.32rem 0;
      }
    }
    .img-wrapper {
      & > div {
        flex: 0 0 auto;
        width: 5.92rem;
        height: 2.27rem;
        margin-bottom: 0.16rem;
      }
      & > div:nth-of-type(2n) {
        margin-left: 0.16rem;
      }
    }
  }
</style>
